<template>
  <div>
    <!-- 头部 S -->
    <div class="header">
      <div class="w top">
        <span class="fl">タオバオ・アリババ・天猫から楽々と輸入事業へ</span>
        <div class="login fr">
          <ul>
            <li v-if="userInfo" class="user">
              <div class="user-img fl">
                <img :src="userInfo.data.pic" alt />
              </div>
              <div class="user-name fl">{{ userInfo.data.ddusername }}</div>
              <a href="#" @click="outInfo">| ログアウト</a>
            </li>
            <li v-else>
              <router-link to="/login">ログイン</router-link>
            </li>
            <li>|</li>
            <li v-if="userInfo == undefined">
              <router-link to="/register">新規会員登録</router-link>
            </li>
            <li v-else>
              <router-link to="/user/index">マイページ</router-link>
            </li>
            <li>|</li>
            <li>
              <a href="javascript:;">レート：{{ rate }}</a>
              <!-- <router-link to="/rateEcharts" style="margin-left: 10px"
                >详细</router-link
              > -->
            </li>
            <!-- <li>|</li>
            <li>
              <router-link to="/">聊天</router-link>
            </li> -->
          </ul>
        </div>
        <!-- 意见反馈 -->
        <div class="feedback" @click="showFeedback" :class="{ home: home == 'home' }">
          <img src="../../assets/img/user_home/problem.png" alt="" />
          改善要望
        </div>
      </div>
      <Fixationnav></Fixationnav>
    </div>
    <!-- 进入AI系统 -->
    <div class="rakuAi" @click="rakuaiAutoLogin">
      <img src="https://www.rakumart.com/assets/img/rakuai.f7e38c22.svg" alt="">
    </div>
    <!-- 头部 E -->
    <!-- 意见弹框 -->
    <el-dialog title="改善リクエスト" :visible.sync="isFeedback" width="600px" center>
      <div class="Feedback-box">
        <p>
          当サイトの使い勝手がわるいところや改善したい所がございましたら、下記の枠にご記入頂ければ、改善可能の限り対応させていただきます。<br />

          宜しくお願い致します。
        </p>
        <div class="upload">
          <h6>画像</h6>
          <el-upload action="https://www.rakumart-2c.com:8080/api/upload/uploadFile" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess" :file-list="fileList" drag name="file" :data="{
              token: token,
            }">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <div class="text">
          <textarea v-model="val" ref="textarea" placeholder="コピーした写真の直接貼り付けCtrl+Vも可能"></textarea>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isFeedback = false">キャンセル</el-button>
        <el-button type="primary" @click="feedback">提出</el-button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { getRate, postSuggest, uploadFile, rakuaiAutoLogin } from "../../api/API/home";
import Fixationnav from "../fixationNav/Fixationnav";

export default {
  data() {
    return {
      rate: "",
      isFeedback: false,
      dialogImageUrl: "",
      dialogVisible: false,
      val: "",
      fileList: [],
      token: localStorage.getItem("token"),
      home: this.$route.name,
    };
  },
  components: {
    Fixationnav,
  },
  computed: {
    // 登入状态
    ...mapState(["userInfo"]),
  },

  created() {
    this.getRate();
    let token = localStorage.getItem("token");
    if (token) {
      document.cookie = `rakumart2c=${token}`;
    }

    // console.log(document.cookie);
    // this.getUsers();
  },
  //   mounted() {
  //     this.$refs["text-input"].addEventListener("paste", this.handlePaste);
  //   },
  //   beforeDestroy() {
  //     this.$refs["text-input"].removeEventListener("paste", this.handlePaste);
  //   },
  methods: {
    // 退出登入
    ...mapMutations(["outInfo", "getExchangeRate"]),
    // 获取汇率
    getRate() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getRate",
      };
      getRate(list).then((res) => {
        this.rate = res.data;
        this.getExchangeRate(res.data);
      });
    },
    // 显示意见框
    showFeedback() {
      if (this.token) {
        this.isFeedback = true;
        setTimeout(() => {
          this.$refs.textarea.addEventListener("paste", this.handlePaste);
        }, 1000);
        this.$nextTick(() => { });

        // this.$refs["text-input"].addEventListener("paste", this.handlePaste);
      } else {
        this.$router.push("/login");
      }
    },
    // 删除
    handleRemove(file, fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      let flag = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
        flag = false;
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        flag = false;
      }
      return flag;
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      this.fileList.push(file);
      //   this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 粘贴事件
    handlePaste(e) {
      let clipboardData = e.clipboardData;
      let file;
      if (
        clipboardData &&
        clipboardData.files &&
        clipboardData.files.length > 0
      ) {
        file = clipboardData.files[0];
      }
      if (typeof file === "undefined") {
        return;
      }
      let param = new FormData();
      param.append("file", file);
      param.append("token", this.token);
      if (clipboardData.files[0].type.indexOf("image") != -1) {
        uploadFile(param).then((res) => {
          this.fileList.push({
            response: res,
            url: res.data,
          });
        });
      }
    },
    // 提交
    feedback() {
      let datas = {
        token: this.token,
        url: "https://www.rakumart-2c.com/#" + this.$route.fullPath,
        content: this.val,
        pic: [],
      };
      this.fileList.forEach((item) => {
        datas.pic.push(item.response.data);
      });
      postSuggest(datas).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.isFeedback = false;
      });
    },
    //获取AI登录token
    rakuaiAutoLogin() {
      if (!this.token) return this.$router.push('/login')
      rakuaiAutoLogin({ token: this.token }).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        window.open('https://aitest.rakumart.com/homepage?token=' + res.data.access_token, '_blank')
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  height: 30px;
  background: #222;
  font-size: 12px;

  span {
    font-size: 12px;
    color: #fff;
    line-height: 30px;
  }

  .user {
    .user-img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      //   background-color: pink;
      margin-top: 5px;
      margin-right: 5px;

      img {
        width: 20px;
      }
    }

    .user-name {
      margin-right: 5px;
      color: #f3c622;
    }
  }

  li {
    float: left;
    margin-left: 10px;
    color: #fff;
    line-height: 30px;

    a {
      &:hover {
        color: #f3c622;
      }

      color: #fff;
      font-size: 12px;
      line-height: 30px;
    }
  }
}

.rakuAi {
  position: fixed;
  bottom: 10%;
  left: 0;
  width: 80px;
  height: 80px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 10px 0 rgba(61, 61, 61, .2);
  z-index: 1001;
  cursor: pointer;

  img {
    width: 80px;
    height: 80px;
  }
}

.top {
  position: relative;

  .feedback {
    position: absolute;
    top: 80px;
    right: 0px;
    text-align: center;
    width: 96px;
    height: 24px;
    background: #f5f5f5;
    border-radius: 2px;
    cursor: pointer;
    padding: 8px 16px;
    z-index: 99;

    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  .home {
    top: 80px;
  }
}

.Feedback-box {
  /deep/.el-upload-dragger {
    width: 148px;
    height: 148px;
  }

  margin: 10px;

  .upload {
    margin: 20px 20px 0;

    h6 {
      font-size: 18px;
      font-weight: 700;
    }
  }

  .text {
    margin: 20px 20px 0;

    textarea {
      resize: none;
      height: 100px;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 5px;
      font-size: 16px;
    }
  }
}
</style>